import { Injectable, Signal, inject } from '@angular/core';
import { Store } from '@ngrx/store';

import { UserPreferencesActions } from '@core/store/user-preferences/user-preferences.actions';
import { selectSoundEnabled } from '@core/store/user-preferences/user-preferences.selectors';

export type SoundType = 'success' | 'error' | 'info';

@Injectable({ providedIn: 'root' })
export class SoundService {
  private readonly store = inject(Store);
  private readonly soundEnabled: Signal<boolean> =
    this.store.selectSignal(selectSoundEnabled);
  private sounds: Record<SoundType, HTMLAudioElement> = {
    success: new Audio('/sounds/success.mp3'),
    error: new Audio('/sounds/error.mp3'),
    info: new Audio('/sounds/info.mp3')
  };

  enableSounds(): void {
    this.store.dispatch(UserPreferencesActions.setSoundEnabled({ enabled: true }));
  }

  disableSounds(): void {
    this.store.dispatch(UserPreferencesActions.setSoundEnabled({ enabled: false }));
  }

  isSoundActive(): boolean {
    return this.soundEnabled();
  }

  play(type: SoundType): void {
    if (!this.isSoundActive()) return;

    const audio = this.sounds[type];
    audio.currentTime = 0;
    audio.play().catch((err) => console.warn('Cannot play sound:', err));
  }
}
